import BasePolicy from '@/policies/BasePolicy.js';

export default class ActivityPolicy extends BasePolicy {
    view(user, activity) {
        // this causes the dropdown "Schedule" to be invisible to students because there is no course at a global level
        // return user.hasPermissionViaCourseTo(activity.course, 'view an activity');

        return true;
    }

    bypassPrereq(user, course) {
        return user.hasPermissionViaCourseTo(course, 'bypass prerequisite activities');
    }

    bypassVisibility(user, course) {
        return user.hasPermissionViaCourseTo(course, 'bypass not visible activities');
    }

    create(user, course) {
        const permission = 'create an activity';

        return user.hasPermissionTo(permission) || user.hasUnlimitedScopePermissionTo(permission);
    }

    update(user, activity) {
        return user.hasPermissionViaCourseTo(activity.course, 'edit an activity');
    }

    delete(user, activity) {
        return user.hasPermissionViaCourseTo(activity.course, 'delete an activity');
    }
}
